import { ServicePluginDefinition } from '@wix/sdk-types';
import {
  Context,
  GetEventBadgeRequest,
  GetEventBadgeResponse,
} from './service-plugins-types.js';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import {
  renameKeysFromSDKRequestToRESTRequest,
  renameKeysFromRESTResponseToSDKResponse,
} from '@wix/sdk-runtime/rename-all-nested-keys';

const TRANSFORM_PATHS_0 = [{ path: 'request.event.publishedDate' }];

export interface GetEventBadgeEnvelope {
  request: GetEventBadgeRequest;
  metadata: Context;
}

export const provideHandlers = ServicePluginDefinition<{
  /**
   *
   * Returns a badge to display on a specific event.
   *
   * Wix calls this method synchronously when the storefront or dashboard reads
   * events with the `BADGES` fieldset requested. For each event in the read
   * pipeline, Wix fans out to every applicable installed implementer in parallel.
   *
   * Wix uses the returned `badge` to surface contextual information on the event
   * card. If multiple badges apply, downstream UI ranks them by `badgeType`
   * priority and most recent implementer edit time. Aggregated badge results are
   * cached per site and event.
   *
   * **Error handling:** If your implementation returns an error or times out, Wix
   * logs the failure and omits your badge for that request. Other implementers'
   * badges can still appear, and no retries are performed at the service plugin layer. */
  getEventBadge(
    payload: GetEventBadgeEnvelope
  ): GetEventBadgeResponse | Promise<GetEventBadgeResponse>;
}>('EVENTS_EVENT_BADGES', [
  {
    name: 'getEventBadge',
    primaryHttpMappingPath: '/v1/event-badge',
    transformations: {
      toREST: (payload: any) => {
        const toRestResponse = payload;

        return renameKeysFromSDKRequestToRESTRequest(toRestResponse);
      },
      fromREST: (payload: any) => {
        const fromRestRequest = transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: TRANSFORM_PATHS_0,
          },
        ]);

        return renameKeysFromRESTResponseToSDKResponse(fromRestRequest);
      },
    },
  },
]);
